<template>
  <div class="search-result">
    <div class="filter-top">
      <!-- 搜索 -->
      <div class="search-box">
        <div class="left-icon" @click="$router.go(-1)">
          <img src="../assets/images/left.png" alt  />
        </div>
        <input type="text" placeholder="请搜索型号或者相关信息" @click="$router.push('/search')" />
        <div class="icon">
          <img src="../assets/images/tabbar/sousuohei@2x.png" alt />
        </div>
        <span>搜索</span>
      </div>
      <!-- 搜索条件 -->
      <div class="filter">
        <ul>
          <li
            v-for="(item,index) in filterList"
            :key="index"
            :class="current == index ? 'active':''"
            @click="filterSearch(index)"
          >
            <span>{{item.title}}</span>
            <div v-if="item.icon">
              <span class="up" :class="{'price-active-up' : current==index && desc=='top'}"></span>
              <span class="down" :class="{'price-active-down' : current==index && desc=='bottom'}"></span>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- 商品展示 -->
    <div class="product">
      <SearchProduct :prodStockDocs="prodStockDocs" v-if="!showFlag" />
      <NoProduct :img="imgsrc" text="抱歉，没有搜到您要的商品" :btnFlag="false" v-if="showFlag" />
    </div>
    <!-- 筛选 -->
    <van-popup
      v-model="filterShow"
      position="right"
      :style="{ height: '100%',width:'80%',background:'#f5f5f5' }"
    >
      <div class="filter-wrap">
        <div class="list" :class="categoryRotate ? 'open-wrap' : 'close-wrap'">
          <div class="title">
            <span>分类</span>
            <p @click="openList('category')">
              全部
              <van-icon
                name="arrow-up"
                style="vertical-align: top;margin-left: 5px;"
                :class="categoryRotate ? 'bottom-arrow' : 'up-arrow'"
              />
            </p>
          </div>
          <ul>
            <li
              v-for="(item,index) in categoryNames"
              :key="index"
              @click="chooseItem(index,item,'category')"
              :class="categoryIndex == index ? 'active-item' : ''"
            >
              <p>{{item}}</p>
            </li>
          </ul>
        </div>
        <div class="list" :class="brandRotate ? 'open-wrap' : 'close-wrap'">
          <div class="title">
            <span>品牌</span>
            <p @click="openList('brand')">
              全部
              <van-icon
                name="arrow-up"
                style="vertical-align: top;margin-left: 5px;"
                :class="brandRotate ? 'bottom-arrow' : 'up-arrow'"
              />
            </p>
          </div>
          <ul>
            <li
              v-for="(brand,index) in brands"
              :key="index"
              @click="chooseItem(index,brand,'brand')"
              :class="brandIndex == index ? 'active-item' : ''"
            >
              <p>{{brand}}</p>
            </li>
          </ul>
        </div>
        <div class="list" :class="packRotate ? 'open-wrap' : 'close-wrap'">
          <div class="title">
            <span>封装规格</span>
            <p @click="openList('pack')">
              全部
              <van-icon
                name="arrow-up"
                style="vertical-align: top;margin-left: 5px;"
                :class="packRotate ? 'bottom-arrow' : 'up-arrow'"
              />
            </p>
          </div>
          <ul>
            <li
              v-for="(pack,index) in packs"
              :key="index"
              @click="chooseItem(index,pack,'pack')"
              :class="packIndex == index ? 'active-item' : ''"
            >
              <p>{{pack}}</p>
            </li>
          </ul>
        </div>
        <div class="btn">
          <button @click="reset">重置</button>
          <button class="comfire" @click="confirm">确定</button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import SearchProduct from "../components/SearchProduct";
import { prodSearch } from "../request/api";
import NoProduct from '../components/NoProduct'
export default {
  name: "searchResult",
  data() {
    return {
      rotate: false,
      filterShow: false,
      showFlag:false,//没有搜索到商品时显示
      prodStockDocs: [],
      brands: [],
      categoryNames: [],
      packs: [],
      current: 0,
      desc: "",
      keyword:'',
      categoryRotate: false,
      brandRotate: false,
      packRotate: false,
      categoryIndex: null,
      brandIndex: null,
      packIndex: null,
      categoryName: "",
      brandName: "",
      packName: "",
      imgsrc:require('../assets/images/search/img_no_search@2x.png'),
      filterList: [
        {
          title: "综合"
        },
        {
          title: "销量"
        },
        {
          title: "价格",
          icon: true
        },
        {
          title: "筛选"
        }
      ]
    };
  },
  components: {
    SearchProduct,
    NoProduct
  },
  created() {
    let categoryName = this.$route.params.categoryName
    let keyword = this.$route.params.keyword
    if(categoryName){
      this.keyword = categoryName
    } else {
      this.keyword = keyword
    }
    this.getSearchPro(this.keyword);
  },
  methods: {
    // 获取搜索信息
    getSearchPro(keyword,type,categoryNames,brand,pack) {
      let data = {
        sortType: type,
        current:0,
        size:10,
        categoryName:this[categoryNames],
        brand:this[brand],
        pack:this[pack]
      }
      // 区分从分类或者从搜索进来，分类关键字为categoryName，搜索关键字为keyword
      if(this.$route.params.categoryName){
        data.categoryName = keyword
      } else {
        data.keyword = keyword
      }
      prodSearch(data).then(res => {
        if (res.status == 200 && res.data.prodStockDocs.length > 0) {
          this.prodStockDocs = res.data.prodStockDocs;
          this.brands = res.data.brands;
          this.categoryNames = res.data.categoryNames;
          this.packs = res.data.packs;
          this.prodStockDocs.forEach(el => {
            this.$set(el, "rotate", false);
          });
          this.showFlag = false;
        } else {
          this.showFlag = true
        }
      });
    },
    //价格,销量,综合排序
    filterSearch(index) {
      this.current = index;
      this.desc =
        index == 2 && this.desc == "bottom"
          ? (this.desc = "top")
          : (this.desc = "bottom");
      switch (index) {
        case 0:
          this.getSearchPro(this.keyword, "COMPREHENSIVE");
          break;
        case 1:
          this.getSearchPro(this.keyword, "INVENTORY_DESC");
          break;
        case 2:
          if (this.desc == "bottom") {
            this.getSearchPro(this.keyword, "PRICE_DESC");
          } else {
            this.getSearchPro(this.keyword, "PRICE_ASC");
          }
          break;
        case 3:
          this.filterShow = true;
      }
    },
    //筛选展开全部
    openList(type) {
      switch (type) {
        case "category":
          this.categoryRotate = !this.categoryRotate;
          break;
        case "brand":
          this.brandRotate = !this.brandRotate;
          break;
        case "pack":
          this.packRotate = !this.packRotate;
      }
    },
    //选择筛选效果
    chooseItem(index, item,type) {
      switch(type){
        case 'category':
          this.categoryIndex = index;
          this.categoryName = item;
          break;
        case 'brand':
          this.brandIndex = index;
          this.brandName = item;
          break;
        case 'pack':
          this.packIndex = index;
          this.packName = item;
      }
    },
    //重置筛选选择
    reset(){
      this.categoryIndex = null;
      this.brandIndex = null;
      this.packIndex = null;
    },
    //确定筛选排序
    confirm(){
      this.getSearchPro(this.keyword,'COMPREHENSIVE','categoryName','brandName','packName');
      this.filterShow = false;
    }
  }
};
</script>

<style lang="less" scoped>
.search-result {
  width: 100%;
  height: 100%;
  background: #f5f5f5;
}
.filter-top {
  position: fixed;
  border-bottom: 1px solid #f3f3f3;
  background: #fff;
  top: 0;
  z-index: 99;
}
.search-box {
  width: 100%;
  height: 90px;
  display: flex;
  align-items: center;
  padding: 0 30px;
  box-sizing: border-box;
  position: relative;
  font-size: 30px;
  input {
    width: 550px;
    height: 72px;
    line-height: 72px;
    background: #f5f5f5;
    border-radius: 8px;
    padding-left: 70px;
    box-sizing: border-box;
    border: solid 1px #dcdcdc;
    margin-right: 15px;
  }
  .left-icon {
    height: 43px;
    width: 43px;
    margin-right: 20px;
    float: left;
    img{
      width: 100%;
      height: 100%;
    }
  }
  .icon {
    position: absolute;
    left: 115px;
    top: 28px;
    width: 36px;
    height: 36px;
    img{
      width: 100%;
      height: 100%;
    }
  }
  span {
    color: #333;
  }
}
.product {
  margin-top: 214px;
}
// 搜索条件
.filter {
  margin-top: 15px;
  ul {
    display: flex;
    padding: 30px 60px;
    justify-content: space-between;
    li {
      color: #333;
      font-size: 28px;
      position: relative;
      .up {
        position: absolute;
        top: 23%;
        right: -50%;
        width: 0;
        height: 0;
        border-bottom: 10px solid #999;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
      }
      .down {
        position: absolute;
        top: 75%;
        right: -50%;
        width: 0;
        height: 0;
        border-top: 10px solid #999;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
      }
      .price-active-up {
        border-bottom: 10px solid #ff9900;
      }
      .price-active-down {
        border-top: 10px solid #ff9900;
      }
    }
    .active {
      color: #ff9900;
    }
  }
}
// 筛选
.filter-wrap {
  height: 90%;
  overflow-y: scroll;
  .list {
    background: #fff;
    padding: 20px;
    margin-bottom: 30px;
    .title {
      font-size: 28px;
      margin-bottom: 20px;
      p {
        font-size: 24px;
        color: #666;
        float: right;
      }
    }
    ul {
      display: flex;
      flex-wrap: wrap;
      li {
        width: 175px;
        height: 96px;
        background: #f5f5f5;
        font-size: 26px;
        color: #666;
        text-align: center;
        border-radius: 10px;
        margin: 0 15px 15px 0;
        padding: 10px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: center;
        p {
          overflow: hidden;
          line-height: 40px;
        }
      }
      .active-item {
        background: #fff;
        color: #ff9900;
        border: 1px solid #ff9900;
      }
      li:nth-child(3n) {
        margin-right: 0;
      }
    }
  }
  .open-wrap {
    height: auto;
  }
  .close-wrap {
    height: 360px;
    overflow: hidden;
  }
  .up-arrow {
    transition: 0.3s;
    transform: rotate(180deg);
  }
  .bottom-arrow {
    transition: 0.3s;
    transform: rotate(0);
  }
  .btn {
    width: 100%;
    height: 106px;
    position: fixed;
    bottom: 0;
    border-top: 1px solid #f2f2f2;
    background: #fff;
    display: flex;
    button {
      flex: 1;
      font-size: 30px;
      border: none;
      background: #fff;
    }
    .comfire {
      background: #ff6600;
      color: #fff;
    }
  }
}
</style>